module.exports = __webpack_public_path__ + "static/media/bg.2493dc44.svg";